export const FourPointFour = () => {
  return (
    <div>
      {" "}
      <div className="row">
        <div className="col-lg-4">
          <img
            className="profile-image"
            id="imageMain4point4"
            src="/images/executioners/4point4-0.jpg"
            alt="4Point4 Foundation campaign"
            style={{ margin: "10px 0" }}
          />
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-1.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-2girl.png')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-3.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-4.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-5.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-6.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-7.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
          <div
            className="col-lg-3 backgroundCoverCenter imageSub4point4"
            style={{
              backgroundImage: "url('images/executioners/4point4-8.jpg')",
              height: "88px",
              margin: "10px 0",
            }}
          ></div>
        </div>
        <div className="col-lg-8">
          <div className="modal-title-container">
            <h3 className="modal-title" id="contactModalLabel">
              4POINT4
            </h3>
          </div>
          <div className="modal-body-container">
            <p className="helvetica-nueue">
              <strong>OBJECTIVE</strong>
            </p>
            <p>
              This is a start up company, founded by Paul Scialla, with
              philanthropy in its DNA. As various lines of business evolved one
              of our primary goals was to explore channels to monetize, promote
              and support the development of sports among deserving youth.
            </p>
            <p>
              All of the below are examples of the process to find and refine
              business models, find a voice, hone a brand, The following
              represent only a few of the places where sport meets need in
              underserved communities and only a few of the people who helped
              us.
            </p>
            <p id="list-4point4-execution">EXECUTION</p>
            <p>
              Bus shelters with UPC codes allowed you to scan and order on the
              spot
            </p>
            <p>T Shirts fund raiser for a soccer stadium in Haiti</p>
            <p>Yoga Mat with history of yoga </p>
            <p>MAP 4.4 Millions Days of Fitness</p>
            <p>Exercise Balls</p>
            <p>Print Ads highlight the problem and suggest solutions</p>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
